import React, { ReactNode, useContext } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { auth } from '../firebase/config';
import { Routes } from 'common/enums';
import { appContext } from 'common/contexts/appContext';

interface EditorRouteProps extends Omit<RouteProps, 'render'> {
  children: ReactNode;
}

const EditorRoute = ({ children, ...rest }: EditorRouteProps) => {
  const context = useContext(appContext);
  const isAdmin = context?.state?.isAdmin || false;
  const isEditor = context?.state?.isEditor || false;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.currentUser ? (
          isAdmin || isEditor ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: Routes.Terminal,
                state: { from: location, error: 'Acceso denegado: Se requiere rol de administrador o editor' }
              }}
            />
          )
        ) : (
          <Redirect
            to={{
              pathname: Routes.SignIn,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

export default EditorRoute;
